import React, { useRef, useState, useEffect } from 'react';
import './ExpandableContainer.style.css';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const ExpandableContainer = ({
  maxWidth = '100%',
  padding = 0,
  backgroundColor = '#FFFFFF',
  maxRows = 5,
  children = null,
  style = {},
  isExpand = false,
  setIsExpand = () => {},
  borderRadius = 0,
  expandButton,
  expandButtonStyle = {},
  position = 'right',
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const expandRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(isExpand);
  const [maxHeight, setMaxHeight] = useState(null);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 토글
   * --
   */
  const handleToggleExpanded = () => {
    if (setIsExpand) {
      setIsExpand(!isExpanded);
    }
    setIsExpanded(!isExpanded);
  };

  /* ===== Variable ===== */
  const childrenRows = React.Children.count(children);

  /* ===== Hooks ===== */
  useEffect(() => {
    if (expandRef.current) {
      const allChildren = expandRef.current.children;
      let totalHeight = 0;

      Array.from(allChildren).forEach((child, index) => {
        if (index < maxRows) {
          totalHeight += child.offsetHeight;
        }
      });
      setMaxHeight(totalHeight);
    }
  }, [children, maxRows]);

  /* ===== Render ===== */
  return (
    <>
      <div
        className="expandable_layout"
        style={{
          maxWidth: maxWidth,
          padding: padding,
          background: backgroundColor,
          borderRadius: borderRadius,
          ...style,
        }}
      >
        <div
          ref={expandRef}
          className="expandable_content"
          style={{
            maxHeight: isExpanded ? '100%' : maxHeight,
            // maxHeight: '100%',
          }}
        >
          {children}
        </div>
      </div>

      {childrenRows > maxRows && (
        <button
          className="expand_button"
          aria-expanded={isExpanded}
          style={{
            ...expandButtonStyle,
            float: position,
          }}
          onClick={() => handleToggleExpanded()}
        >
          {expandButton ? (
            expandButton
          ) : (
            <>
              상세검색 {isExpanded ? '접기' : '펼치기'}
              <span>{isExpanded ? <UpOutlined /> : <DownOutlined />}</span>
            </>
          )}
        </button>
      )}
    </>
  );
};

export default ExpandableContainer;
